import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLVideoElement>('.video__video', async ($video) => {
  const { PlyrLayout, VidstackPlayer } = await import(/* webpackChunkName: "vidstack" */ 'vidstack/global/player');
  const { videoTranslations } = $video.dataset;

  await VidstackPlayer.create({
    target: $video,
    layout: new PlyrLayout({
      translations: videoTranslations ? JSON.parse(videoTranslations) : undefined,
    }),
  });
});
